var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pa-0" }, [
        _c("h4", [_vm._v("Confirm Review Actions")])
      ]),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "px-0 pb-3 pt-1" }, [
        _c("p", { staticClass: "mb-0" }, [
          _vm._v(
            "\n      Please review the changes you've made below, then confirm to finish the\n      review. Please note that no more changes can be made after review\n      submission. If a change needs to be made please ask a campaign admin to\n      reset the asset\n    "
          )
        ]),
        _vm._v(" "),
        _vm.reviewsToConfirm.length === 0
          ? _c("section", { key: "no-reviews" }, [
              _c(
                "p",
                { staticClass: "font-weight-medium d-inline-block mb-0 pt-2" },
                [_vm._v("\n        There is nothing to review.\n      ")]
              )
            ])
          : _c(
              "section",
              { key: "has-reviews", attrs: { id: "reviewList" } },
              _vm._l(_vm.reviewsToConfirm, function(review, idx) {
                return _c(
                  "article",
                  { key: idx },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "font-weight-medium d-inline-block mb-0 pt-2"
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(review.name) + "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "asset-review-step-confirm-table-container",
                          attrs: { id: "AssetReviewConfirmTable" }
                        },
                        [
                          _c("sphere-table", {
                            key: _vm.tableKey,
                            ref: "AssetReviewConfirmTable",
                            refInFor: true,
                            attrs: {
                              "data-items":
                                review.name === "Dependencies to Onboard"
                                  ? review.items
                                  : _vm.addChangesToItems(review.items),
                              columns: _vm.AssetColumns[review.name],
                              name: "Asset Review Step confirm"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("v-divider")
                  ],
                  1
                )
              }),
              0
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }